module.exports = __webpack_public_path__ + "static/media/do.526509b9.svg";